module.exports = __webpack_public_path__ + "img/Slice2-min.e303dc83.png";